import { mockQuoteDetails } from '@domgen/dgx-fe-basket';
import { PaymentTerm } from '@domgen/dgx-fe-common';
import { CheckoutItemDetails } from '../../models/checkout-item/checkout-item-details.interface';

export const mockCheckoutItemDetails: CheckoutItemDetails = {
  fee: mockQuoteDetails.directDebitPaymentOption?.fee ?? 0,
  itemId: mockQuoteDetails.itemId,
  itemType: mockQuoteDetails.itemType,
  periodOfCover: 24,
  paymentTerm: PaymentTerm.IndefinitePayMonthly,
  quoteId: mockQuoteDetails.quoteId,
};
